<template>
    <div>
        <label for="name"></label>
        <input id="name" @input="$emit('name', $event.target.value)" @focus="$emit('disable-error', false)"
               type="text" placeholder="Name on card" autocomplete="name" :class="{error: redBorder}"/>
    </div>
</template>

<script>

export default {
  name: 'NameOnForm',
  data() {
    return {};
  },
  props: {
    error: {
      required: true,
      type: Boolean,
    },
  },
  computed: {
    redBorder() {
      return this.error ? 1 : 0;
    },
  },
  methods: {},
  beforeMount() {},
  mounted() {},
  updated() {},
};
</script>

<style scoped>
    .error {
        border-color: #fa755a;
        border-width: 1px;
    }
    input {
        box-shadow: 0 1px 3px 0 #e6ebf1;
        border-width: 0;
    }
</style>
